var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 3.82198C29.7646 6.90864 27.2624 14.4154 21.089 20.5888C14.9158 26.762 7.409 29.2643 4.32234 26.1776C1.23568 23.0909 3.73791 15.5843 9.91124 9.41088C16.0845 3.23755 23.5913 0.735308 26.6779 3.82198ZM4.3221 3.82215C1.23544 6.90882 3.73766 14.4155 9.91099 20.5889C16.0843 26.7623 23.591 29.2645 26.6776 26.1778C29.7644 23.0911 27.2621 15.5844 21.0888 9.41105C14.9155 3.23773 7.40875 0.735484 4.3221 3.82215Z",
    stroke: "#1A2A6C",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 14.9999C18.625 16.7258 17.2259 18.1249 15.5 18.1249C13.7741 18.1249 12.375 16.7258 12.375 14.9999C12.375 13.274 13.7741 11.8749 15.5 11.8749C17.2259 11.8749 18.625 13.274 18.625 14.9999Z",
    stroke: "#1A2A6C",
    strokeWidth: 1.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtom);
export default __webpack_public_path__ + "static/media/icon-atom.f7ff423b36671f4c590285e2cdc8eaf4.svg";
export { ForwardRef as ReactComponent };